export const clientActionTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER'
};